const route = {
  path: '/usercard/:tenant',
  name: 'CustomerCard',
  meta: { routeName: '客户名片' },
  component: () =>
    import(/* webpackChunkName: 'customerCard' */ '@/views/customerCard')
}
export default route
